module.exports = __webpack_public_path__ + "static/Logo-2228a98a5c81d38e920537eccd4b8227.png";